import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../redux/store';
import { SideBetTargetBackground } from './sideBetTargetBackground';
export const SideBetTargetBackgroundsContainer = ({ startTimestampMs }) => {
    const validSideBetSeatIndexes = useAppSelector((state) => {
        return state.poker.seatedPlayerSeatIndexes.filter((seatIndex) => {
            if (state.poker.mySeatIndex === seatIndex) {
                // can never side bet on yourself
                return false;
            }
            const seatedPlayer = state.poker.seatedPlayers[seatIndex];
            if (!seatedPlayer) {
                return false;
            }
            return seatedPlayer.isIn;
        });
    }, shallowEqual);
    return (_jsx(_Fragment, { children: validSideBetSeatIndexes.map((validSideBetSeatIndex) => (_jsx(SideBetTargetBackground, { seatIndex: validSideBetSeatIndex, startTimestampMs: startTimestampMs }, validSideBetSeatIndex))) }));
};
